export default {"src":"/_next/static/media/facebook_icon.db80b35a.svg","height":56,"width":56};